import { geoJsonFile } from '../config';

const dataURLs = {
  data: `https://truiiqao.blob.core.windows.net/dashboard/${process.env.REACT_APP_YEAR}_lga_data.json`,
  geo: `${process.env.PUBLIC_URL}/data/${geoJsonFile}`,
};

export const getCouncilData = () => {
  return fetch(dataURLs.data).then((response) => response.json());
};

export const getQldCouncilGeo = () => {
  return fetch(dataURLs.geo).then((response) => response.json());
};



// WEBPACK FOOTER //
// ./src/api/index.js